/**
 * The continuous sounds' single notes (05 §2): the amoeba's bubbling and the magic wall's
 * tinkling are random blips at random gaps while the state lasts. The cover crackle is a
 * steady noise and lives in ambience.ts. Pure.
 */

import { midiToHz } from '../notes';
import { between, intBelow, type Rand } from '../rand';
import type { VoiceSpec } from '../voice';
import { hit } from './kit';

/** One bubble: a low pulse "bloop" through a resonant filter opening upward. */
export function amoebaBlip(r: Rand): VoiceSpec[] {
  const f = midiToHz(40 + intBelow(r, 16));
  return [
    {
      ...hit('pulse', f, 0.07, 0.12),
      width: 0.3,
      to: f * 1.5,
      glide: 0.05,
      filter: { type: 'lowpass', freq: 400, to: 1200, sweep: 0.05, q: 10 },
    },
  ];
}

/** One tinkle: a very short high triangle, anywhere from G6 to A#7. */
export function magicTinkle(r: Rand): VoiceSpec[] {
  return [hit('triangle', midiToHz(91 + intBelow(r, 16)), 0.14, 0.09)];
}

/** Seconds to the next blip: about three bubbles a second, five or six tinkles. */
export function nextGap(r: Rand, kind: 'amoeba' | 'magic'): number {
  return kind === 'amoeba' ? between(r, 0.12, 0.5) : between(r, 0.06, 0.3);
}
